import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { PriceFilter, SaleFilter } from 'Blocks'

class MobilePriceView extends Component {
  static propTypes = {
    data: PropTypes.shape({
      products: PropTypes.shape({
        aggregations: PropTypes.shape({
          sales: PropTypes.any
        })
      })
    }),
    history: PropTypes.any,
    queryString: PropTypes.any
  }

  render() {
    return (
      <div className="price-filter__filter panel">
        <div className="price-filter-container">
          {this.props.data && (
            <Fragment>
              <PriceFilter
                queryString={this.props.queryString}
                history={this.props.history}
                data={this.props.data}
                titleEnabled={false}
              />
              <SaleFilter
                queryString={this.props.queryString}
                isDisabled={!this.props.data.products.aggregations.sales}
              />
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default MobilePriceView
